export const GET_EMAIL_DOCUMENT = 'GET_EMAIL_DOCUMENT'
export const GET_EMAIL_DOCUMENT_COMPLETE = 'GET_EMAIL_DOCUMENT_COMPLETE'

export const LINK_MESSAGE_TO_CLAIM = 'LINK_MESSAGE_TO_CLAIM'
export const LINK_MESSAGE_TO_CLAIM_COMPLETE = 'LINK_MESSAGE_TO_CLAIM_COMPLETE'

export const MESSAGES_PAGINATION = 'MESSAGES_PAGINATION'

export const MESSAGES_COLUMN_CLICK = 'MESSAGES_COLUMN_CLICK'

export const SEND_EMAIL = 'SEND_EMAIL'
export const SEND_EMAIL_COMPLETE = 'SEND_EMAIL_COMPLETE'

export const GET_TAGS_FOR_CLAIM_MESSAGE = 'GET_TAGS_FOR_CLAIM_MESSAGE'
export const GET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE = 'GET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE'

export const SET_TAGS_FOR_CLAIM_MESSAGE = 'SET_TAGS_FOR_CLAIM_MESSAGE'
export const SET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE = 'SET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE'

export const DOWNLOAD_MESSAGE_ATTACHMENT = 'DOWNLOAD_MESSAGE_ATTACHMENT'

export const PREVIEW_EMAIL = 'PREVIEW_EMAIL'
export const PREVIEW_EMAIL_COMPLETE = 'PREVIEW_EMAIL_COMPLETE'

export const MESSAGE_VIEWER_CLOSED = 'MESSAGE_VIEWER_CLOSED'

export const SET_MESSAGE_TASK = 'SET_MESSAGE_TASK'

export const SET_MESSAGE_DELETED = 'SET_MESSAGE_DELETED'